import script from "./webSocketPage.vue?vue&type=script&setup=true&lang=js"
export * from "./webSocketPage.vue?vue&type=script&setup=true&lang=js"

import "./webSocketPage.vue?vue&type=style&index=0&id=f3032f0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3032f0a"]])

export default __exports__